<template>
  <HeaderComponent :domain-search-to-url="domainSearchToUrl" :search-button-text="searchButtonText" />
  <div class="flex-grow bg-white relative flex-1 pb-16">
    <div class="hidden overflow-hidden [overflow-anchor:none] 2xl:block 2xl:absolute 2xl:inset-y-0 2xl:h-full 2xl:w-full">
      <div class="relative h-full text-lg max-w-prose mx-auto" aria-hidden="true">
        <svg v-if="!$slots['aside-right']" class="absolute top-12 left-full translate-x-32 transform" width="404" height="384" fill="none" viewBox="0 0 404 384">
          <defs>
            <pattern id="74b3fd99-0a6f-4271-bef2-e80eeafdf357" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="404" height="384" fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)" />
        </svg>
        <svg class="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
          <defs>
            <pattern id="f210dbf6-a58d-4871-961e-36d5016a0f49" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="404" height="384" fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
        </svg>
        <svg class="absolute bottom-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
          <defs>
            <pattern id="d3eb07ae-5182-43e6-857d-35c643af9034" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="404" height="384" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)" />
        </svg>
      </div>
    </div>
    <div class="flex flex-col justify-between flex-1">
      <div class="relative flex justify-center gap-6 px-4 sm:px-6 lg:px-8">
        <aside class="w-80 not-prose hidden 2xl:block">
          <slot name="aside-left" />
        </aside>
        <main class="prose prose-indigo prose-lg text-gray-500 min-w-0 max-w-[46rem]">
          <slot name="content" />
        </main>
        <aside class="w-80 not-prose hidden xl:block">
          <slot name="aside-right" />
        </aside>
      </div>
    </div>
  </div>
  <FooterComponent />
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';

const props = defineProps({
  domainSearchToUrl: {
    type: Function as PropType<(encodedDomain: string) => string>,
    default: (encodedDomain: string) => `/domains/${encodedDomain}/dns-records/`,
  },
  searchButtonText: {
    type: String,
    default: undefined,
  },
});
</script>
